export default function DS_Regression_Table() {
  return <div>DS_Regression_Table Component</div>;
}
